import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
class Nav extends Component {
	render() {
		return (
			<nav className="main-header navbar navbar-expand navbar-white navbar-light">
				{/* Left navbar links */}
				<ul className="navbar-nav" style={{ cursor: 'pointer' }}>
					<li className="nav-item">
						<a className="nav-link" data-widget="pushmenu" href="#void" role="button">
							<i className="fas fa-bars" />
						</a>
					</li>
				</ul>
			</nav>
		);
	}
}

export default hot(module)(Nav);
